import { action } from 'typesafe-actions';
import { ICardDetails, ITokenizeCardRequest } from 'types';
import * as ActionTypes from './types';

export const createTokenizedCardRequest = (body: ITokenizeCardRequest) => action(ActionTypes.Card.CREATE_TOKENIZED_CARD_REQUEST, { body });
export const createTokenizedCardSuccess = (response: ICardDetails) => action(ActionTypes.Card.CREATE_TOKENIZED_CARD_SUCCESS, response);
export const createTokenizedCardFail = (error: any) => action(ActionTypes.Card.CREATE_TOKENIZED_CARD_FAIL, error);

export const getCardRequest = (cardId: string) => action(ActionTypes.Card.GET_CARD_REQUEST, { cardId });
export const getCardSuccess = (response: ICardDetails) => action(ActionTypes.Card.GET_CARD_SUCCESS, response);
export const getCardFail = (error: any) => action(ActionTypes.Card.GET_CARD_FAIL, error);

export const deleteCardRequest = (cardId: string) => action(ActionTypes.Card.DELETE_CARD_REQUEST, { cardId });
export const deleteCardSuccess = (response: ICardDetails) => action(ActionTypes.Card.DELETE_CARD_SUCCESS, response);
export const deleteCardFail = (error: any) => action(ActionTypes.Card.DELETE_CARD_FAIL, error);
